import { WithdrawalsSetDistributionSettingsProcessedItemsReducer } from './types';

export const withdrawalsSetDistributionSettingsProcessedItemsReducer: WithdrawalsSetDistributionSettingsProcessedItemsReducer =
  (state, action) => {
    const { items } = action.payload;

    return {
      ...state,
      withdrawalsDistributionSettingsProcessedItems: items,
    };
  };
